export default __webpack_public_path__ + "static/media/upload.c42899bb.gif";